const NAME = "PERFORMANCE_EVALUATIONS_CALIBRATION";

export default NAME;
